import { render, staticRenderFns } from "./LaptopIcon.vue?vue&type=template&id=629b3f41&scoped=true&"
import script from "./LaptopIcon.vue?vue&type=script&lang=js&"
export * from "./LaptopIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629b3f41",
  null
  
)

export default component.exports